import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useCurrentSociety } from '../../../../hooks/useCurrentSociety'
// eslint-disable-next-line max-len
import { FunctionSettingsCustomWidget } from '../../../../components/society/FunctionSettings/FunctionSettingsCustomWidget'
import { widgetQueries } from '../../../../api/society-widgets'

export const FunctionSettingsCustomWidgets = (): React.ReactNode => {
  const { society } = useCurrentSociety()

  const { data: widgets } = useQuery(
    widgetQueries.getWidgetsPerSociety(society?._id)
  )

  return (
    <div className="mt-2 space-y-2">
      {widgets?.map((widget) => (
        <FunctionSettingsCustomWidget key={widget._id} widget={widget} />
      ))}
    </div>
  )
}
